import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog } from '@mui/material';
import Progress from '../../progress/Progress';
import FormService from '../../../services/form/FormService';
import ModalCard, { ModalRow, ModalTitle } from '../../modal/ModalCard';

interface DeleteFormModalProps {
    isShowDelete: boolean;
    setIsShowDelete: (v: boolean) => void;
    groupId: number;
    setUpdateForms: Dispatch<SetStateAction<number>>;
}
const DeleteFormModal = ({ isShowDelete, setIsShowDelete, groupId, setUpdateForms }: DeleteFormModalProps) => {
    const { t } = useTranslation(['common', 'admin']);
    const [isFormSending, setIsFormSending] = useState(false);

    const closeModal = () => {
        setIsShowDelete(false);
        setIsFormSending(false);
    };

    const onDeleteForm = () => {
        setIsFormSending(true);
        FormService.DeleteFormTemplateByGroupId(groupId)
            .then(() => setUpdateForms((old) => old + 1))
            .finally(() => closeModal());
    };

    return (
        <Dialog open={isShowDelete} onClose={closeModal}>
            <ModalCard sx={{ borderRadius: 4, height: '100%', overflow: 'auto' }} title={t('form:deleteForm')} closeCallback={closeModal}>
                <form>
                    <ModalCard.Main isDivider={false}>
                        <ModalRow>{t('form:deleteFormWarning')}</ModalRow>
                    </ModalCard.Main>

                    <ModalCard.Action>
                        <Progress isLoading={isFormSending}>
                            <Button type="submit" variant="contained" color="error" onClick={onDeleteForm}>
                                <ModalTitle>{t('form:deleteForm')}</ModalTitle>
                            </Button>
                        </Progress>
                    </ModalCard.Action>
                </form>
            </ModalCard>
        </Dialog>
    );
};

export default DeleteFormModal;
